// extracted by mini-css-extract-plugin
export default {"container":"coocies_consent_container__wPb1D","text":"coocies_consent_text__HYPn7","link":"coocies_consent_link__95iL2 coocies_consent_text__HYPn7"};